import { pipeText } from '../../../shared/pipeText'

var pipingnMixin = {
    methods: {
        answerToText: function (answer) {
            switch (answer.type) {
                case 'number':
                    return answer.number
                case 'phone_number':
                    return answer.phone_number
                case 'date':
                    return answer.date
                case 'boolean':
                    if (answer.boolean) {
                        return 'Tak'
                    } else {
                        return 'Nie'
                    }
                case 'text':
                    return answer.text
                case 'choices':
                    let str = ''
                    for (let i = 0; i < answer.choices.length; i++) {
                        if (str.length > 0) {
                            str = str + ', '
                        }
                        str = str + answer.choices[i].label
                    }
                    return str
            }
        },
        applyVariables: function (string) {
            const planId = Number(typeof window !== 'undefined' && window.plan ? window.plan.planId : 1)

            return pipeText(string, {
                hidden: this.store && this.store.hidden,
                answers: this.store && this.store.answers,
                variables: this.store && this.store.variables,
                components: this.form && this.form.components,
                responseToken: this.responseToken,
                responseTime: this.responseTime,
            }, {
                allowLinks: planId !== 0,
                booleanLabels: { yes: 'Tak', no: 'Nie' },
            })
        }
    }
}
export default pipingnMixin
